
var Model = require("../types/Model.js");

module.exports = Model({
	name: "ownresources",
	init: init,
	uninit: uninit,
	triggers: triggers,
	listeners: listeners,

	_viewingResource: null,
	_resourcesList: null,
	_needSearch: null,
	_action: null,

	reset: reset,
	searchResource: searchResource,
	viewresource: viewresource
});

function init() {
	this._resourcesList = [],
	this.reset();
}

function uninit() {
	this._resourcesList = null;
	this.reset();
}

function triggers() {
	return {
		"viewresource": viewresource,
		"open": openResources,
		"reset": reset,
		"closeresource": closeresource,
		"search": searchResource,
		"close": hideResources
	};
}

function listeners() {
	return {
		"ownresourceslist:updated": updateList,
	};
}

function hideResources(){
	this.dispatch("resource:hidden");
	if(this._action)
		this.emit("activeworkflowaction:trigger:view", {
			action: this._action
		});
	this._action = null;
	this.emit("usermetrics:trigger:track", "close own resources");
}

function openResources() {
	this.emit("ownresourceslist:trigger:list");
	this.dispatch("open");
	this.emit("usermetrics:trigger:track", "open list of own resources");
}

function closeresource() {
	const currentResource = this._viewingResource;
	this._viewingResource = null;
	this.extend({
		viewingResource: null
	});
	this.emit("usermetrics:trigger:track", "close own resource", {
		resource: currentResource
	});
}

function viewresource(data) {
	this._viewingResource = data.id;
	this.extend({
		viewingResource: data.id
	});
	this.dispatch("detail");
	this.api.resources.saveViewed(data.id);
	this.emit("usermetrics:trigger:track", "view own resource", {
		resource: data.id
	});
}

function updateList(data) {
	var viewing = this._viewingResource;
	var update = {
		resources: data
	};
	this._resourcesList = data;

	var exists = data.reduce(function(acc, resource){
		if(resource._id === viewing) return true;
		return acc;
	}, false);

	if(!exists && viewing){
		this._viewingResource = null;
		update.viewingResource = null;
		this.dispatch("close");
	}

	this.extend(update);

	if(this._needSearch) {
		this.searchResource(this._needSearch);
	}
}

function reset() {
	this._viewingResource = null;
	this._needSearch = null;
	this.push({
		viewingResource: null,
		resources: [],
		open: false
	});
}

function searchResource(data) {
	var id = data.id;
	var list = this._resourcesList;
	this._action = data.action;
	var theResource = null;
	if(list.length === 0) {
		this.emit("ownresourceslist:trigger:list");
		this._needSearch = data;
	}else {
		this._needSearch = null;
		theResource = list.find(function(resource) {
			return resource._id === id;
		});
		if(theResource) {
			var sendObj = {
				id: theResource._id
			};
			this.dispatch("open");
			this.viewresource(sendObj);
		}else {
			this.emit("toast:trigger:show", {
				content: "resources.0",
				style: "error"
			});
		}
	}
}